<template>
    <div class="rounded bg-blue-bg w-full p-6">
        <h2 class="mb-4 font-noto-sans text-2xl font-semibold leading-tight tracking-tight text-grey-darkest">
            We're making renting<br>
            <span class="text-blue">better for everyone</span>
        </h2>

        <p class="mb-6">
            Rentora makes it easy to manage your properties, collect your rent and more.
        </p>

        <grid-layout v-if="!isSmall">
            <grid-layout-item class="mb-6">
                <router-link
                    :to="{
                        name: 'www.tenants.index'
                    }"
                    class="flex items-center mb-3 font-noto-sans font-semibold text-blue"
                >
                    For tenants

                    <base-svg
                        name="icon-cheveron-right"
                        class="w-6 h-6 fill-primary-blue"
                    />
                </router-link>

                <ul>
                    <li
                        v-for="(perk, index) in [
                            'Pay rent online',
                            'Build your credit history just by paying rent',
                            'Apply to properties listed on Rentora',
                        ]"
                        :key="index"
                        class="flex items-top mb-3"
                    >
                        <base-svg
                            name="icon-check-circle"
                            class="flex-none w-6 h-6 fill-primary-white fill-secondary-blue mr-2"
                        />

                        {{ perk }}
                    </li>
                    <li class="ml-8">
                        <router-link
                            :to="{
                                name: 'www.tenants.index'
                            }"
                            class="text-blue"
                        >
                            More...
                        </router-link>
                    </li>
                </ul>
            </grid-layout-item>

            <grid-layout-item>
                <router-link
                    :to="{
                        name: 'www.landlords.index'
                    }"
                    class="flex items-center mb-3 font-noto-sans font-semibold text-blue"
                >
                    For landlords &amp; agents

                    <base-svg
                        name="icon-cheveron-right"
                        class="w-6 h-6 fill-primary-blue"
                    />
                </router-link>

                <ul>
                    <li
                        v-for="(perk, index) in [
                            'Free property listings',
                            'Collect payments from an unlimited number of tenants/roommates',
                            'Upload and share inventories',
                        ]"
                        :key="index"
                        class="flex items-top mb-3"
                    >
                        <base-svg
                            name="icon-check-circle"
                            class="flex-none w-6 h-6 fill-primary-white fill-secondary-blue mr-2"
                        />

                        {{ perk }}
                    </li>
                    <li class="ml-8">
                        <router-link
                            :to="{
                                name: 'www.landlords.index'
                            }"
                            class="text-blue"
                        >
                            More...
                        </router-link>
                    </li>
                </ul>
            </grid-layout-item>
        </grid-layout>

        <template v-else>
            <router-link
                :to="{
                    name: 'www.tenants.index'
                }"
                class="flex items-center mb-3 font-noto-sans font-semibold text-blue"
            >
                For tenants

                <base-svg
                    name="icon-cheveron-right"
                    class="w-6 h-6 fill-primary-blue"
                />
            </router-link>

            <router-link
                :to="{
                    name: 'www.landlords.index'
                }"
                class="flex items-center font-noto-sans font-semibold text-blue"
            >
                For landlords &amp; agents

                <base-svg
                    name="icon-cheveron-right"
                    class="w-6 h-6 fill-primary-blue"
                />
            </router-link>
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            isSmall: {
                type: Boolean,
                default: false
            }
        }
    }
</script>
